import imageDefault from "assets/imageDefault.png";
import Fav from "assets/StarOutlined.svg";
import FavSelected from "assets/Star.svg";
import errorCircle from "assets/errorCircle.svg";
import starWhite from "assets/starWhite.svg";
import marker from "assets/marker.svg";

export const texts = {
  fumico: "kd meu fumico",
  next: "avançar",
  back: "voltar",
  fav: "favoritos",
  recents: "recentes",
  selectAddress: "selecione o seu endereço",
  orderPrevious: "previsão de entrega",
  orderActive: "continue o seu pedido",
  outOfArea: "endereço fora da área de entrega",
  inOfArea: "endereço dentro da área de entrega",
  noAddressesFavorites: "você não possui endereços favoritos.",
};

export const images = {
  imageDefault,
  Fav,
  FavSelected,
  errorCircle,
  starWhite,
  marker,
};
